import convertToPrice from '@/utils/convertToPrice';

const columns = () => ([
  {
    title: 'Display name',
    dataIndex: 'displayName',
    key: 'displayName',
  },
  // {
  //   title: 'Description',
  //   dataIndex: 'displayText',
  //   key: 'displayText',
  // },
  // {
  //   title: 'Disclaimer',
  //   dataIndex: 'disclaimer',
  //   key: 'disclaimer',
  // },
  {
    title: 'Price',
    dataIndex: 'price',
    key: 'price',
    customRender: ({ text }) => convertToPrice(text),
  },
  {
    title: 'Additional discount',
    dataIndex: 'additionalDiscount',
    key: 'additionalDiscount',
    customRender: ({ text }) => convertToPrice(text),
  },
  {
    title: 'Is tax applied',
    dataIndex: 'isTaxApplied',
    key: 'isTaxApplied',
    customRender: ({ text }) => `${text ? 'Yes' : 'No'}`,
  },
  {
    title: 'Is toggle',
    dataIndex: 'isToggle',
    key: 'isToggle',
    customRender: ({ text }) => `${text ? 'Yes' : 'No'}`,
  },
  {
    title: 'Is main product',
    dataIndex: 'isMainOption',
    key: 'isMainOption',
    customRender: ({ text }) => `${text ? 'Yes' : 'No'}`,
  },
  {
    title: 'Is show',
    dataIndex: 'visible',
    key: 'visible',
    customRender: ({ text }) => `${text ? 'Yes' : 'No'}`,
  },
  {
    title: 'Depend products quantity',
    dataIndex: 'dependQuantityProductIds',
    key: 'dependQuantityProductIds',
    customRender: ({ text }) => `${text && text.length > 0 ? 'Yes' : 'No'}`,
  },
  {
    title: 'Company',
    dataIndex: 'company',
    key: 'company',
  },
  {
    title: 'Actions',
    dataIndex: 'actions',
    key: 'actions',
  },
]);

export default columns;
